import { Component, OnInit, ViewChild, Directive } from '@angular/core';
import { ClienteLogin, ClienteXCiudad } from "../../../login/cliente_login";
import { correctHeight, detectBody } from "../../../../app.helpers";
import { SessionStorageService } from "ngx-webstorage/dist/services";
import { HandleError } from "../../../../components/common/utils/handleError.component";
import { Router } from '@angular/router';
import { SessionTokenService } from "../../../../components/common/utils/sessionToken.service";
import { PolizasVencidasNoLiberadasService } from "./polizas-vencidasnoLiberadas.service";
import { PolizasVencidasNoLiberadasEntity } from "../entities/polizas-vencidasnoLiberadas_entity";
import { ClienteXAseguradoraEntity } from "../entities/clientexseguradora_entity";
import { ListaDiccionaryEntity } from "../../../../components/common/utils/entities/lista_dictionary_entity";
import { DetallePolizasVencidasEntity } from "../entities/detalle-polizas-vencidas_entity";
import { ModalComponent } from "ng2-bs3-modal/ng2-bs3-modal";


const swal = require("sweetalert2");

declare var jQuery: any;
@Component({
    selector: 'polizasVencidas',
    providers: [PolizasVencidasNoLiberadasService],
    templateUrl: 'polizas-vencidasnoLiberadas.template.html',
    // styleUrls: ["datos-generales-empresa.style.css"]

})

export class PolizasVencidasNoLiberadas implements OnInit {  
    showLoader: string;
    usuario: ClienteLogin;
    userEmpresa:ClienteXCiudad;
    clienteAseg: ClienteXAseguradoraEntity;    
    listaPolizasVencidas: PolizasVencidasNoLiberadasEntity[];
    listaAseguradoras:ListaDiccionaryEntity[];
    listaDetallePolizas:DetallePolizasVencidasEntity[];
    poliza: string;
     inicial: number;
     filterQuery: string;
      @ViewChild('detallePolizas')
    modal: ModalComponent;

    constructor(private polizasVencidasNoLiberadasService: PolizasVencidasNoLiberadasService,
        private router: Router,
        private sessionTokenService: SessionTokenService,
        private handleError: HandleError,
        public sesionStorageService: SessionStorageService
    ) {
    }

      ngOnInit(): void {
           this.inicial = 0;
       /*correctHeight();
        detectBody();*/
        this.showLoader = "sk-loading";        
        try {
            this.usuario = jQuery.parseJSON(this.sesionStorageService.retrieve("usuario"));
        } catch (e) {
            this.usuario = this.sesionStorageService.retrieve("usuario");
        }
        if (this.usuario == null) {
            let error = { "status": 998, "message": "Acceso denegado" };
            this.handleError.redirectUrl(error)
        } else {
            let bandera = this.sessionTokenService.useJwtHelper();
            if (!bandera) {
                this.listaPolizasVencidas = new Array<PolizasVencidasNoLiberadasEntity>();
                this.clienteAseg= new ClienteXAseguradoraEntity;
                this.listaAseguradoras= new Array<ListaDiccionaryEntity>();               

                try {
                    this.userEmpresa = jQuery.parseJSON(this.sesionStorageService.retrieve("usuarioEmpresa"));
                    this.clienteAseg.cliente=this.userEmpresa;
                   
                } catch (e) {
                    this.userEmpresa = this.sesionStorageService.retrieve("usuarioEmpresa");
                    this.clienteAseg.cliente=this.userEmpresa;
                    
                }
                  
                this.CargarAseguradoras();
                
                this.sesionStorageService.observe("usuarioEmpresa").subscribe(a => {
                    try {
                        this.userEmpresa = jQuery.parseJSON(a);
                    } catch (e) {
                        this.userEmpresa = a;
                    }
                    this.CargarAseguradoras();
                })
            }
        }
    }

    CargarAseguradoras(){
           this.polizasVencidasNoLiberadasService.consultarListaAseguradorasXCliente(this.userEmpresa).subscribe(aseguradoras => {
            this.listaAseguradoras = aseguradoras;
            this.inicial = this.listaAseguradoras[0].Codigo; 
            this.CargarPolizas(this.inicial);
            //this.showLoader = "";           

        }, error => this.handleError.redirectUrl(error));
    }

    CargarPolizas(aseCod:number) {               
        this.clienteAseg.AseCod=aseCod;
        this.polizasVencidasNoLiberadasService.consultarListaPolizasNoLiberadas(this.clienteAseg).subscribe(polizas => {
            this.listaPolizasVencidas = polizas;
            this.showLoader = "";         
        }, error => this.handleError.redirectUrl(error));     
    }

    CargarDetallePolizasVencidas(poliza:PolizasVencidasNoLiberadasEntity){
        this.polizasVencidasNoLiberadasService.consultarListaDetallePolizasVencidas(poliza).subscribe(detalle=>{
            this.listaDetallePolizas= detalle;
            this.poliza= poliza.PolCod;
            this.modal.open();            
        }, error => this.handleError.redirectUrl(error));    
    }


}


// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/views/empresas/fianzas/polizasVencidasNoLiberadas/polizas-vencidasnoLiberadas.component.ts